import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon } from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from "../../components/AuthContext";
import moment from "moment";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../components/UtilContext";
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { cleanSorters, parseSorters, parseMaskFilters, safeParse, extractSafePaginationParams, createDedupedAjaxRequest, rowPassesCalibrationStateListHeaderFilters, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { getPusherChannel } from '../../utils/pusherChannel';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
const GAUGE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'specific_id': 'Calibration.Column.SerialOrder',
  'inventory_number': 'Calibration.Column.InventoryNumber',
  'gauge_name': 'Common.Name',
  'gauge_status': 'Calibration.Column.GaugeStatute',
  'gauge_type': 'Calibration.Column.GaugeType',
  'gauge_description': 'Calibration.Column.GaugeDescription',
  'gauge_category': 'Calibration.Column.GaugeCategory',
  'max_calibration_interval': 'Calibration.Column.MaxCalibrationInterval',
  'trustee.department.name': 'Calibration.Column.AdminDepartment',
  'trustee.name': 'Calibration.Column.AdminName',
  'user.department.name': 'Calibration.Column.UserDepartment',
  'user.name': 'Calibration.Column.UserName',
  'calibration_company.name': 'Calibration.Column.CalibrationCompany',
  'serial_number': 'Common.Column.SerialNumber',
  'manufacturer': 'Common.Column.Manufacturer',
  'purchase_date': 'Calibration.Column.PurchaseDate',
  'location': 'Calibration.Column.Location',
  'state': 'Calibration.Column.GaugeState',
  'required_attachment': 'Common.MandatoryAttachment',
  'id': 'Calibration.Column.SerialOrder',
});


export default function GaugeList({preview=null}){

    const [state,dispatch] = useContext(DatabaseContext);
    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter, openChosenNotificationPreferences} = useContext(UtilContext);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(!user?.permissions?.includes('add calibration'));
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_GAUGE = { specific_id: true, inventory_number: true, gauge_name: true, gauge_status: true, gauge_type: true, gauge_description: true,
      gauge_category: true, max_calibration_interval: true, 'trustee.department.name': true, 'trustee.name': true, 'user.name': true, 'user.department.name': true, 'calibration_company.name': true, serial_number: true, manufacturer: true, purchase_date: true, location: true, state: true, required_attachment: true,
    };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_GAUGE });
    const [maskVisible, setMaskVisible] = useState(false);
const [editFormGauge, setEditFormGauge] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const tableBuiltRef = useRef(false);
    const [tableReady, setTableReady] = useState(false);
    const useMaskDefaultsRef = useRef(true);
    const lastMaskSigRef = useRef("");
    const isRestoringRef = useRef(false);
    const userInteractedRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const needsRedrawRef = useRef(false);
    const pendingRowIdsRef = useRef(new Set());
    const rafRedrawRef = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    const isTableVisible = useCallback(() => {
      const table = getTable();
      if (!table) return false;
      const el = table.getElement?.() ?? table.element ?? table.rowManager?.element?.parentElement;
      return !!(el && el.offsetParent != null && el.clientHeight > 0);
    }, [getTable]);

    const scheduleRedraw = useCallback(() => {
      if (rafRedrawRef.current != null) return;
      rafRedrawRef.current = requestAnimationFrame(() => {
        const table = getTable();
        rafRedrawRef.current = null;
        if (!table) return;
        const ids = Array.from(pendingRowIdsRef.current);
        pendingRowIdsRef.current.clear();
        needsRedrawRef.current = false;
        const headerFilters = table.getHeaderFilters?.() ?? [];
        ids.forEach((id) => {
          const row = table.getRow?.(id);
          if (!row) return;
          const data = row.getData?.();
          if (!data) return;
          if (!rowPassesCalibrationStateListHeaderFilters(data, headerFilters)) { row.delete?.(); return; }
          row.reformat?.();
        });
      });
    }, [getTable]);

    const captureHScroll = useCallback(() => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);

    const restoreHScroll = useCallback(() => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    }, [getTable]);

    useEffect(() => {
      const channel = getPusherChannel();
      if (!channel) return;
      const DEDUPE_MS = 800;
      const lastHandled = { key: '', at: 0 };
      const shouldSkip = (eventType, id) => {
        if (id == null) return true;
        const key = `${eventType}-${id}`;
        const now = Date.now();
        if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
        lastHandled.key = key;
        lastHandled.at = now;
        return false;
      };
      const onCreated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.created', id)) return;
        getRequest(`/api/gauges/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
          pendingRowIdsRef.current.add(rowData.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        }).catch(() => {});
      };
      const onUpdated = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.updated', id)) return;
        getRequest(`/api/gauges/${id}`).then((res) => {
          const rowData = res?.data ?? res;
          if (!rowData?.id) return;
          const table = getTable();
          const row = table?.getRow?.(rowData.id);
          if (row) row.update(rowData);
          else table?.addData?.([rowData], true);
          pendingRowIdsRef.current.add(rowData.id);
          if (isTableVisible()) scheduleRedraw();
          else needsRedrawRef.current = true;
        }).catch(() => {});
      };
      const onDeleted = (data) => {
        const id = data?.id ?? null;
        if (id == null || shouldSkip('gauge.deleted', id)) return;
        const table = getTable();
        const row = table?.getRow?.(id) ?? table?.getRows?.().find((r) => r.getData().id === id);
        if (row) row.delete();
      };
      channel.bind('gauge.created', onCreated);
      channel.bind('gauge.updated', onUpdated);
      channel.bind('gauge.deleted', onDeleted);
      return () => {
        channel.unbind('gauge.created', onCreated);
        channel.unbind('gauge.updated', onUpdated);
        channel.unbind('gauge.deleted', onDeleted);
      };
    }, [getTable, isTableVisible, scheduleRedraw]);

    useEffect(() => {
      const n = state.refreshGaugeList ?? 0;
      if (n > 0) {
        userInteractedRef.current = true;
        captureHScroll();
        refreshFromStart();
      }
    }, [state.refreshGaugeList, getTable, captureHScroll]);

    useEffect(() => {
      if (needsRedrawRef.current && isTableVisible()) scheduleRedraw();
    }, [isTableVisible, scheduleRedraw]);

    // ResizeObserver: keď sa záložka zoznamu znova zobrazí (návrat z detailu), prekresli tabuľku – oprava neúplného náhľadu (rovnako ako intr003)
    const lastContainerHeightRef = useRef(0);
    useEffect(() => {
      const el = elementRef.current;
      if (!el || typeof ResizeObserver === 'undefined') return;
      const ro = new ResizeObserver(() => {
        const h = el.clientHeight;
        if (h > 0) {
          const wasHidden = lastContainerHeightRef.current <= 0;
          lastContainerHeightRef.current = h;
          if (wasHidden) requestAnimationFrame(() => getTable()?.redraw?.(true));
        } else {
          lastContainerHeightRef.current = 0;
        }
      });
      ro.observe(el);
      return () => ro.disconnect();
    }, [getTable]);

    // Refresh list po uložení z GaugeAdd
    useEffect(() => {
      const n = state.refreshGaugeList ?? 0;
      if (n === 0) return;
      userInteractedRef.current = true;
      captureHScroll();
      refreshFromStart();
    }, [state.refreshGaugeList, getTable, captureHScroll]);

    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

    function matchAny(data, filterParams) {
      //data - the data for the row being filtered
      //filterParams - params object passed to the filter
      //RegExp - modifier "i" - case insensitve
  
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
  
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

      function searchTable(){
        const t = getTable();
        if (t) t.setFilter(matchAny, { value: searchValue });
        setSearchIconColor("active");
        if (searchValue === " ") getTable()?.clearFilter?.();
        setVisibleSearch(false);
      }
    
        const accept = () => {
            const rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            if (rows_to_delete.length === 0) return;
            setVisibleLoading(true);
            setDialogText?.(t('Common.Deleting'));
            setVisible?.(true);
            const promises = rows_to_delete.map(element =>
              deleteRequest(`/api/gauges/${element.id}`)
            );
            Promise.allSettled(promises).then((results) => {
              setVisible?.(false);
              setVisibleLoading(false);
              const successCount = results.filter(r => r.status === 'fulfilled').length;
              const failCount = results.filter(r => r.status === 'rejected').length;
              if (successCount > 0 && failCount === 0) {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
              } else if (failCount > 0) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              }
              if (successCount > 0) refreshFromStart();
            });
        }
    
        const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
        }
    
        const confirm = () => {
            confirmDialog({
                message: t('Common.ConfirmDeleteRecord'),
                header: t('Common.ConfirmDelete'),
                icon: 'pi pi-info-circle',
                acceptClassName: 'p-button-danger',
                acceptLabel: t('Common.Yes'),
                rejectLabel: t('Common.No'),
                accept,
                reject
            });
        };
    
      const rowClick = (e, row) => {
        console.log(e, row);
     };
    
      const onSelectRow = (data, rows) => {
        setEditFormGauge(data);
          if(data.length === 0){
            setEditIcon(true);
            setCopyIcon(true);
            setDeleteIcon(true);
          }
          else{
            if(user?.permissions?.includes('edit calibration'))setEditIcon(false);
            if(user?.permissions?.includes('add calibration'))setCopyIcon(false);
            if(user?.permissions?.includes('delete calibration'))setDeleteIcon(false);
          }
      };

      function onEditRow(gauge){
        const t = getTable();
        const filters = (t?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
        const sorters = cleanSorters(t?.getSorters?.() || []);
        const navigationContext = { filters, sorters };
        dispatch({ type: 'create_new_tab', name: t('Calibration.EditGauge'), translationKey: 'Calibration.EditGauge', legacyLabel: t('Calibration.EditGauge'), page: 'GaugeAdd', props: { gauge_id: gauge?.id, type: 'edit', navigationContext }, mask: 'calb003' });
      };
      
      function EditRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
      }

      function TrusteeDepartmentFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.trustee?.department?.name ?? ''}</span>;
      }
      function TrusteeNameFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.trustee?.name ?? ''}</span>;
      }
      function UserNameFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.user?.name ?? ''}</span>;
      }
      function UserDepartmentFormatter(props) {
        const d = props.cell.getRow().getData();
        return <span>{d?.user?.department?.name ?? ''}</span>;
      }

      const [draggingItem,setDraggingItem] = useState(null); 
      const [columns,setColumns] = useState([
        { title: '', field: 'id',formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort:false, resizable:false},
        { title: '', field: 'editor',hozAlign:"center", width: 44, headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
        { title: t('Calibration.Column.SerialOrder'), field: 'specific_id',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Calibration.Column.InventoryNumber'), field: 'inventory_number',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Common.Name'), field: 'gauge_name',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Calibration.Column.GaugeStatute'), field: 'gauge_status',headerFilter:"input", minWidth: 180, widthGrow: 1},
        { title: t('Calibration.Column.GaugeType'), field: 'gauge_type',headerFilter:"input", minWidth: 180, widthGrow: 1},
        { title: t('Calibration.Column.GaugeDescription'), field: 'gauge_description',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Calibration.Column.GaugeCategory'), field: 'gauge_category',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Calibration.Column.MaxCalibrationInterval'), field: 'max_calibration_interval',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Calibration.Column.AdminDepartment'), field: 'trustee.department.name',headerFilter:"input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<TrusteeDepartmentFormatter/>)},
        { title: t('Calibration.Column.AdminName'), field: 'trustee.name',headerFilter:"input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<TrusteeNameFormatter/>)},
        { title: t('Calibration.Column.UserDepartment'), field: 'user.department.name',headerFilter:"input", minWidth: 240, widthGrow: 1, formatter: reactFormatter(<UserDepartmentFormatter/>)},
        { title: t('Calibration.Column.UserName'), field: 'user.name',headerFilter:"input", minWidth: 220, widthGrow: 1, formatter: reactFormatter(<UserNameFormatter/>)},
        { title: t('Calibration.Column.CalibrationCompany'), field: 'calibration_company.name',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Common.Column.SerialNumber'), field: 'serial_number',headerFilter:"input", minWidth: 200, widthGrow: 1},
        { title: t('Common.Column.Manufacturer'), field: 'manufacturer',headerFilter:"input", minWidth: 160, widthGrow: 1},
        { title: t('Calibration.Column.PurchaseDate'), field: 'purchase_date',headerFilter:"input", minWidth: 180, widthGrow: 1},
        { title: t('Calibration.Column.Location'), field: 'location',headerFilter:"input", minWidth: 160, widthGrow: 1},
        { title: t('Calibration.Column.GaugeState'), field: 'state',headerFilter:"input", minWidth: 180, widthGrow: 1},
        { title: t('Common.MandatoryAttachment'), field: 'required_attachment', headerFilter: 'list', headerFilterParams: { values: { ["Áno"]: t('Common.Yes'), ["Nie"]: t('Common.No') }, clearable: true }, headerFilterFunc: (headerValue, rowValue) => { if (!headerValue || headerValue === '') return true; return (headerValue === "Áno" && !!rowValue) || (headerValue === "Nie" && !rowValue); }, minWidth: 200, widthGrow: 1, formatter: (cell) => cell.getValue() ? t('Common.Yes') : t('Common.No') },
      ]);

      const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      const t = getTable();
      const tableReadyForParams = tableBuiltRef.current;
      let hf = [];
      if (tableReadyForParams) hf = t?.getHeaderFilters?.() ?? [];
      if (tableReadyForParams && hf.length) {
        hf.forEach(f => {
          if (f?.field == null) return;
          const v = f.value;
          if (v === undefined || v === null || String(v).trim() === '') return;
          const key = `filter_${f.field}`;
          extra[key] = v;
        });
      } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
        const maskRow = (state.user_mask_filters || []).find(m => m.page === 'GaugeList');
        if (maskRow) {
          parseMaskFilters(maskRow.filters).forEach(f => {
            if (!f?.field) return;
            const v = f.value;
            if (v === undefined || v === null || String(v).trim() === '') return;
            extra[`filter_${f.field}`] = v;
          });
        }
      }
      let sortersFromTable = [];
      if (tableReadyForParams) sortersFromTable = t?.getSorters?.() ?? [];
      const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
      if (hasSorters) {
        const clean = cleanSorters(sortersFromTable);
        if (clean.length > 0) extra.sorters = JSON.stringify(clean);
      } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
        const maskRow = (state.user_mask_filters || []).find(m => m.page === 'GaugeList');
        if (maskRow?.sorters) {
          const parsed = parseSorters(maskRow.sorters);
          if (parsed.length > 0) extra.sorters = JSON.stringify(parsed);
        }
      }
      return extra;
    }, [getTable, state.user_mask_filters, pageSizePc]);

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());
      function addNewGauge(){
        dispatch({type:'create_new_tab',name:t('Calibration.NewGauge'),translationKey:'Calibration.NewGauge',legacyLabel:t('Calibration.NewGauge'),page:'GaugeAdd',props:{gauge: null,type:'add'},mask:'calb003'})
      }
      function copyGauge(){
        const t = getTable();
        const sel = t?.getSelectedData?.()?.[0];
        const filters = (t?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
        const sorters = cleanSorters(t?.getSorters?.() || []);
        const navigationContext = { filters, sorters };
        dispatch({ type: 'create_new_tab', name: t('Calibration.NewGauge'), translationKey: 'Calibration.NewGauge', legacyLabel: t('Calibration.NewGauge'), page: 'GaugeAdd', props: { gauge_id: sel?.id, type: 'copy', navigationContext }, mask: 'calb003' });
      }
      function editGauge(){
        const t = getTable();
        const sel = t?.getSelectedData?.()?.[0];
        const filters = (t?.getHeaderFilters?.() || []).map(f => ({ field: f.field, value: f.value }));
        const sorters = cleanSorters(t?.getSorters?.() || []);
        const navigationContext = { filters, sorters };
        dispatch({ type: 'create_new_tab', name: t('Calibration.EditGauge'), translationKey: 'Calibration.EditGauge', legacyLabel: t('Calibration.EditGauge'), page: 'GaugeAdd', props: { gauge_id: sel?.id, type: 'edit', navigationContext }, mask: 'calb003' });
      }
    
      function confirmPrintDialog(){
        if(printValue=="Zoznam"){
          ref.current.print(false, true)
        }
        else{
          handlePrint();
        }
      }
    
      function handleDragStart(e, item){ 
        setDraggingItem(item);
        e.dataTransfer.setData('text/plain', ''); 
      }; 
  
      function handleDragEnd(){ 
        setDraggingItem(null);
      }; 
  
      function handleDragOver(e){ 
          e.preventDefault(); 
      }; 
  
      function handleDrop(e, targetItem){ 
          if (!draggingItem) return; 
  
          const currentIndex = columns.indexOf(draggingItem); 
          const targetIndex = columns.indexOf(targetItem); 
  
          if (currentIndex !== -1 && targetIndex !== -1) { 
            columns.splice(currentIndex, 1); 
            columns.splice(targetIndex, 0, draggingItem); 
             
          } 
          ref.current.setColumns(columns);
      }; 
    
    function setMask(item, value){
      const columnVisible = { ...columnsVisible };
      columnVisible[item] = value;
      const table = getTable();
      for (const val in columnVisible) {
        if (columnVisible[val] === false) table?.hideColumn?.(val);
        else table?.showColumn?.(val);
      }
      setColumnsVisible(columnVisible);
    }

    const resetMask = () => resetTabulatorMask({
      page: 'GaugeList',
      defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_GAUGE,
      ref,
      columns,
      setColumnsVisible,
    });
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("GaugeList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); refreshFromStart(); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => { setUserMaskFilter("GaugeList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); refreshFromStart(); },
                template: itemRenderer,
            },
             {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("GaugeList", "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => { setUserMaskFilter("GaugeList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('GaugeList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
      if(value){
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=true;
            ref.current.showColumn(`${val}`);
          }
        };
        setColumnsVisible(columnVisible);
      }
      else{
        const columnVisible = {...columnsVisible};
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=false;
            ref.current.hideColumn(`${val}`);
          }
        };
        setColumnsVisible(columnVisible);
      }
    }
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: GAUGE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    

    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewGauge()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editGauge()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyGauge()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => getTable()?.print?.(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => { setSearchIconColor(""); setSearchValue(""); getTable()?.clearFilter?.(); }}>{searchIconColor === "" ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => getTable()?.download?.("xlsx", "data.xlsx", { sheetName: "MyData" })}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { userInteractedRef.current = true; captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Calibration.GaugeList'),"GaugeList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("GaugeList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          setTableReady(true);
          const table = getTable();
          if (!table) return;
          if (preview != null) {
            table.setFilter?.("gauge_status", "=", preview);
          }
          const mask = state.user_mask_filters?.filter(m => m.page === "GaugeList") ?? [];
          if (mask.length > 0 && !preview) {
            isRestoringRef.current = true;
            const attributes = safeParse(mask[0].attributes, []);
            const filters = parseMaskFilters(mask[0].filters);
            const sorters = parseSorters(mask[0].sorters);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) {
              table.setColumnLayout?.(attributes);
            }
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) table.hideColumn?.(column);
                else table.showColumn?.(column);
              }
            }
            if (Array.isArray(sorters) && sorters.length > 0) {
              table.setSort?.(sorters.map(s => ({ column: s.column ?? s.field, dir: s.dir })));
            }
            if (Array.isArray(filters) && filters.length > 0) {
              filters.forEach(f => table.setHeaderFilterValue?.(f.field, f.value ?? "", true));
            } else {
              table.clearHeaderFilter?.();
            }
            setTimeout(() => { isRestoringRef.current = false; }, 0);
            refreshFromStart();
          }
        },
        headerFilterChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; captureHScroll(); refreshFromStart(); },
        sortChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        dataSorted: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        renderComplete: () => restoreHScroll(),
        ...getTabulatorPersistLayoutEvents("GaugeList", ref, setUserMaskFilter),
      }}
      options={{
        layout: "fitColumns",
        renderHorizontal: "virtual",
        rowHeight: 30,
        movableColumns: true,
        headerSortTristate: true,
        ajaxURL: "/api/gauges/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingData'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('GaugeList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
      }}/> 
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.PrintAs')} visible={printVisible} style={{ width: '40vw' }} onHide={() => setPrintVisible(false)}>
        <div className="flex flex-columns">
          <select 
          value={printValue} onChange={e => setPrintValue(e.target.value)}
          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
            <option value="Zoznam">Zoznam</option>                      
          </select>
          <button onClick={() => confirmPrintDialog()} className='w-20 ml-8 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.PrintUpper')}</button>
        </div>
      </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index==0 || index == 1) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                        draggable="true"
                        onDragStart={(e) =>  
                            handleDragStart(e, item)} 
                        onDragEnd={() => handleDragEnd()} 
                        onDragOver={(e) => handleDragOver(e)} 
                        onDrop={(e) => handleDrop(e, item)} 
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("GaugeList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
      </div> 
        </>
    )
}